/* ============================================================
   Slappy Street — efectos de scroll y 3D (sin librerías)
   Todo se desactiva con "reducir movimiento" del sistema.
   ============================================================ */
(function () {
  'use strict';
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = window.matchMedia('(pointer: fine)').matches;
  const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
  const body = document.body;

  // Progreso 0→1 de una sección alta con contenido "sticky"
  const progressOf = (el) => {
    const r = el.getBoundingClientRect();
    const total = r.height - window.innerHeight;
    return total > 0 ? clamp(-r.top / total) : clamp(1 - r.top / window.innerHeight);
  };

  /* ---------- Separar palabras (títulos y texto que se revela) ---------- */
  function splitWords(el) {
    if (el.dataset.splitDone) return;
    const words = el.textContent.trim().split(/\s+/);
    el.textContent = '';
    words.forEach((w, i) => {
      const span = document.createElement('span');
      span.className = 'w';
      span.style.setProperty('--wi', i);
      span.textContent = w;
      el.appendChild(span);
      if (i < words.length - 1) el.appendChild(document.createTextNode(' '));
    });
    el.dataset.splitDone = '1';
  }

  /* ---------- Registro de efectos por cuadro ---------- */
  const tasks = [];
  let ticking = false;
  const run = () => { tasks.forEach((t) => t()); ticking = false; };
  const request = () => { if (!ticking) { ticking = true; requestAnimationFrame(run); } };

  let globalsDone = false;
  function init() {
    $$('[data-split]').forEach(splitWords);
    $$('[data-reveal-words]').forEach(splitWords);
    // Mostrar títulos: en el siguiente cuadro, con respaldo por si el navegador retrasa la animación
    const ready = () => body.classList.add('fx-ready');
    requestAnimationFrame(ready);
    setTimeout(ready, 350);

    if (reduce) {
      $$('[data-reveal-words] .w').forEach((w) => w.classList.add('is-on'));
      return;
    }

    /* Portada: zoom y desvanecido */
    $$('[data-hero-zoom]').forEach((sec) => {
      const media = sec.querySelector('[data-hero-media]');
      const content = sec.querySelector('[data-hero-content]');
      tasks.push(() => {
        const p = progressOf(sec);
        media.style.setProperty('--p', p.toFixed(4));
        content.style.opacity = (1 - p * 1.6).toFixed(3);
        content.style.transform = `translate3d(0, ${(-p * 80).toFixed(1)}px, 0)`;
      });
    });

    /* Anillo 3D */
    $$('[data-ring]').forEach((sec) => {
      const wheel = sec.querySelector('[data-ring-wheel]');
      const items = $$('.ring__item', wheel);
      const setRadius = () => {
        const n = items.length || 1;
        const w = items[0] ? items[0].getBoundingClientRect().width : 240;
        const r = Math.round((w / 2) / Math.tan(Math.PI / n) + w * 0.25);
        wheel.style.setProperty('--r', r + 'px');
      };
      setRadius();
      window.addEventListener('resize', setRadius);
      tasks.push(() => {
        const p = progressOf(sec);
        wheel.style.setProperty('--rot', (-p * 360).toFixed(2) + 'deg');
        items.forEach((it, i) => {
          // Resalta la tarjeta que está al frente
          const angle = ((i / items.length) * 360 - p * 360) % 360;
          const a = ((angle + 540) % 360) - 180;
          it.classList.toggle('is-front', Math.abs(a) < 180 / items.length);
        });
      });
    });

    /* Galería horizontal fija */
    $$('[data-hscroll]').forEach((sec) => {
      const track = sec.querySelector('[data-hscroll-track]');
      const size = () => {
        if (window.innerWidth < 750) { sec.style.height = ''; track.style.transform = ''; sec.classList.add('is-native'); return; }
        sec.classList.remove('is-native');
        const dist = Math.max(0, track.scrollWidth - window.innerWidth);
        sec.style.height = (window.innerHeight + dist) + 'px';
        sec.dataset.dist = dist;
      };
      size();
      window.addEventListener('resize', size);
      window.addEventListener('load', size);
      tasks.push(() => {
        if (sec.classList.contains('is-native')) return;
        const p = progressOf(sec);
        track.style.transform = `translate3d(${(-p * Number(sec.dataset.dist || 0)).toFixed(1)}px, 0, 0)`;
      });
    });

    /* Texto que se revela palabra por palabra */
    $$('[data-text-reveal]').forEach((sec) => {
      const words = $$('[data-reveal-words] .w', sec);
      tasks.push(() => {
        const p = progressOf(sec);
        const on = Math.round(p * 1.15 * words.length);
        words.forEach((w, i) => w.classList.toggle('is-on', i < on));
      });
    });


    /* Tarjeta 3D del fundador: gira con el scroll, se inclina con el mouse y se voltea al tocarla */
    $$('[data-founder]').forEach((stage) => {
      const card = stage.querySelector('[data-founder-card]');
      let mx = 0, my = 0;
      card.addEventListener('click', () => card.classList.toggle('is-flipped'));
      card.setAttribute('role', 'button'); card.tabIndex = 0;
      card.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); card.classList.toggle('is-flipped'); } });
      if (fine) {
        stage.addEventListener('pointermove', (e) => {
          const r = stage.getBoundingClientRect();
          mx = (e.clientX - r.left) / r.width - 0.5; my = (e.clientY - r.top) / r.height - 0.5; request();
        });
        stage.addEventListener('pointerleave', () => { mx = 0; my = 0; request(); });
      }
      tasks.push(() => {
        const r = stage.getBoundingClientRect();
        const p = clamp(1 - (r.top + r.height / 2) / (window.innerHeight + r.height / 2), 0, 1); // 0 abajo → 1 arriba
        const scrollY = (0.5 - p) * 40;
        card.style.setProperty('--fy', (scrollY + mx * 24).toFixed(2) + 'deg');
        card.style.setProperty('--fx', (-my * 18 + (p - 0.5) * 10).toFixed(2) + 'deg');
      });
    });

    /* Dos palabras que se funden */
    $$('[data-duo]').forEach((sec) => {
      const l = sec.querySelector('[data-duo-l]'), r = sec.querySelector('[data-duo-r]');
      const plus = sec.querySelector('[data-duo-plus]'), res = sec.querySelector('[data-duo-result]'), copy = sec.querySelector('[data-duo-copy]');
      tasks.push(() => {
        const p = progressOf(sec);
        const a = clamp(p / 0.55);                 // fase 1: se acercan
        const b = clamp((p - 0.5) / 0.25);         // fase 2: se funden
        const c = clamp((p - 0.7) / 0.25);         // fase 3: aparece el texto
        const off = (1 - a) * 60;
        l.style.transform = `translate3d(${-off}vw, 0, 0) rotateY(${(1 - a) * 50}deg)`;
        r.style.transform = `translate3d(${off}vw, 0, 0) rotateY(${-(1 - a) * 50}deg)`;
        l.style.opacity = r.style.opacity = (1 - b).toFixed(3);
        l.style.filter = r.style.filter = `blur(${(b * 12).toFixed(1)}px)`;
        plus.style.opacity = (a * (1 - b)).toFixed(3);
        plus.style.transform = `scale(${0.4 + a * 0.6}) rotate(${a * 180}deg)`;
        res.style.opacity = b.toFixed(3);
        res.style.transform = `scale(${(0.6 + b * 0.4).toFixed(3)}) translateZ(0)`;
        res.style.letterSpacing = `${(0.6 - b * 0.62).toFixed(3)}em`;
        copy.style.opacity = c.toFixed(3);
        copy.style.transform = `translate3d(0, ${(1 - c) * 40}px, 0)`;
      });
    });

    /* Frase 3D con volumen: sigue al mouse y rota con el scroll */
    $$('[data-tag3d]').forEach((sec) => {
      const stack = sec.querySelector('[data-tag3d-stack]');
      let mx = 0, my = 0;
      if (fine) {
        sec.addEventListener('pointermove', (e) => {
          const r = sec.getBoundingClientRect();
          mx = (e.clientX - r.left) / r.width - 0.5; my = (e.clientY - r.top) / r.height - 0.5; request();
        });
        sec.addEventListener('pointerleave', () => { mx = 0; my = 0; request(); });
      }
      tasks.push(() => {
        const r = sec.getBoundingClientRect();
        const p = clamp(1 - (r.top + r.height / 2) / (window.innerHeight + r.height / 2));
        stack.style.transform = `rotateX(${(18 - p * 36 + my * -16).toFixed(2)}deg) rotateY(${(-22 + p * 44 + mx * 26).toFixed(2)}deg)`;
      });
    });

    /* Mazo de productos que se abre en abanico */
    $$('[data-stack]').forEach((sec) => {
      const cards = $$('.stack__card', sec);
      const n = cards.length;
      tasks.push(() => {
        const p = progressOf(sec);
        const e = 1 - Math.pow(1 - clamp(p / 0.75), 3); // ease-out
        const wide = window.innerWidth > 749;
        cards.forEach((c, i) => {
          const mid = (n - 1) / 2, d = i - mid;
          const x = d * (wide ? 19 : 14) * e;
          const rot = d * (wide ? 9 : 7) * e;
          const y = Math.abs(d) * 18 * e - (1 - e) * i * 6;
          const z = -Math.abs(d) * 60 * e + (1 - e) * i * 4;
          const ry = -d * 14 * e;
          c.style.transform = `translate3d(${x}vw, ${y}px, ${z}px) rotateZ(${rot}deg) rotateY(${ry}deg)`;
          c.style.zIndex = String(100 - Math.round(Math.abs(d) * 10));
        });
      });
    });

    /* Barra de progreso de lectura */
    const bar = document.querySelector('.scroll-progress');
    if (bar) tasks.push(() => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.transform = `scaleX(${max > 0 ? (window.scrollY / max).toFixed(4) : 0})`;
    });

    /* Parallax suave */
    const pars = $$('[data-parallax]');
    if (pars.length) tasks.push(() => {
      const vh = window.innerHeight;
      pars.forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        const f = parseFloat(el.dataset.parallax) || 0.1;
        const off = (r.top + r.height / 2 - vh / 2) * f;
        el.style.setProperty('--py', off.toFixed(1) + 'px');
      });
    });

    if (globalsDone) { request(); return; }
    globalsDone = true;

    /* Velocidad del scroll → inclinación de marquesinas */
    if (body.classList.contains('fx-skew')) {
      let lastY = window.scrollY, skew = 0;
      const loop = () => {
        const y = window.scrollY;
        const v = clamp((y - lastY) * 0.25, -10, 10);
        skew += (v - skew) * 0.12;
        lastY = y;
        body.style.setProperty('--scroll-skew', skew.toFixed(2) + 'deg');
        requestAnimationFrame(loop);
      };
      requestAnimationFrame(loop);
    }

    /* Inclinación 3D de tarjetas */
    if (fine && body.classList.contains('fx-tilt')) {
      document.addEventListener('pointermove', (e) => {
        const card = e.target.closest('[data-tilt]');
        $$('[data-tilt].is-tilting').forEach((c) => { if (c !== card) { c.classList.remove('is-tilting'); c.style.removeProperty('--rx'); c.style.removeProperty('--ry'); } });
        if (!card) return;
        const r = card.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5;
        const y = (e.clientY - r.top) / r.height - 0.5;
        card.classList.add('is-tilting');
        card.style.setProperty('--rx', (-y * 7).toFixed(2) + 'deg');
        card.style.setProperty('--ry', (x * 9).toFixed(2) + 'deg');
        card.style.setProperty('--mx', ((x + 0.5) * 100).toFixed(1) + '%');
        card.style.setProperty('--my', ((y + 0.5) * 100).toFixed(1) + '%');
      }, { passive: true });
    }

    /* Cursor personalizado */
    const cursor = document.querySelector('.cursor');
    if (cursor && fine) {
      const label = cursor.querySelector('.cursor__label');
      let x = -100, y = -100, cx = -100, cy = -100;
      document.addEventListener('pointermove', (e) => {
        x = e.clientX; y = e.clientY;
        const t = e.target.closest('[data-cursor]');
        cursor.classList.toggle('is-big', !!t);
        label.textContent = t ? t.dataset.cursor : '';
        cursor.classList.toggle('is-link', !t && !!e.target.closest('a, button, summary, label'));
      }, { passive: true });
      document.addEventListener('pointerleave', () => cursor.classList.add('is-hidden'));
      document.addEventListener('pointerenter', () => cursor.classList.remove('is-hidden'));
      const follow = () => {
        cx += (x - cx) * 0.2; cy += (y - cy) * 0.2;
        cursor.style.transform = `translate3d(${cx}px, ${cy}px, 0)`;
        requestAnimationFrame(follow);
      };
      body.classList.add('has-cursor');
      requestAnimationFrame(follow);
    }

    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request);
    request();
  }


  /* ---------- Contadores que suben al aparecer ---------- */
  function initCounters() {
    const els = $$('[data-count]:not([data-count-done])');
    const fmt = (v, pad) => String(Math.round(v)).padStart(pad, '0');
    const go = (el) => {
      el.dataset.countDone = '1';
      const end = parseFloat(el.dataset.count) || 0, pad = parseInt(el.dataset.pad, 10) || 0;
      if (reduce) { el.textContent = fmt(end, pad); return; }
      const t0 = performance.now(), dur = 1600;
      const step = (t) => {
        const k = clamp((t - t0) / dur);
        el.textContent = fmt(end * (1 - Math.pow(1 - k, 4)), pad);
        if (k < 1) requestAnimationFrame(step); else el.textContent = fmt(end, pad);
      };
      requestAnimationFrame(step);
      setTimeout(() => { el.textContent = fmt(end, pad); }, dur + 400); // respaldo
    };
    if (!('IntersectionObserver' in window)) { els.forEach(go); return; }
    const io = new IntersectionObserver((en) => en.forEach((x) => { if (x.isIntersecting) { go(x.target); io.unobserve(x.target); } }), { threshold: 0.4 });
    els.forEach((el) => { el.textContent = String(0).padStart(parseInt(el.dataset.pad, 10) || 0, '0'); io.observe(el); });
  }

  /* ---------- Imágenes que se revelan con cortina ---------- */
  function initClip() {
    const els = $$('.cgrid__item, .ed__media, .crail__media, .hgal__media, .founder__stage, .istrip__media');
    els.forEach((el) => el.classList.add('clip'));
    if (reduce || !('IntersectionObserver' in window)) { els.forEach((el) => el.classList.add('is-clipped-in')); return; }
    const io = new IntersectionObserver((en) => en.forEach((x) => { if (x.isIntersecting) { x.target.classList.add('is-clipped-in'); io.unobserve(x.target); } }), { rootMargin: '0px 0px -10% 0px' });
    els.forEach((el) => io.observe(el));
    setTimeout(() => els.forEach((el) => { if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-clipped-in'); }), 1200);
  }

  /* ---------- Botones magnéticos ---------- */
  function initMagnetic() {
    if (reduce || !fine) return;
    $$('[data-magnetic], .btn--xl, .header__cta').forEach((b) => {
      b.addEventListener('pointermove', (e) => {
        const r = b.getBoundingClientRect();
        const x = (e.clientX - r.left - r.width / 2) * 0.25, y = (e.clientY - r.top - r.height / 2) * 0.35;
        b.style.transform = `translate3d(${x.toFixed(1)}px, ${y.toFixed(1)}px, 0)`;
      });
      b.addEventListener('pointerleave', () => { b.style.transform = ''; });
    });
  }

  /* ---------- Transición suave entre páginas ---------- */
  function initTransitions() {
    if (reduce) return;
    document.addEventListener('click', (e) => {
      const a = e.target.closest('a[href]');
      if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || a.target === '_blank') return;
      const url = new URL(a.href, location.href);
      if (url.origin !== location.origin || url.hash && url.pathname === location.pathname) return;
      if (a.hasAttribute('data-cart-open') || /\/(cart|checkout)/.test(url.pathname) && a.closest('[data-cart-drawer]')) return;
      e.preventDefault();
      body.classList.add('is-leaving');
      setTimeout(() => { location.href = a.href; }, 280);
    });
    window.addEventListener('pageshow', () => body.classList.remove('is-leaving'));
  }

  function initStatic() { initCounters(); initClip(); initMagnetic(); initTransitions(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initStatic); else initStatic();

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // Editor de temas: reiniciar efectos al recargar una sección
  document.addEventListener('shopify:section:load', () => { tasks.length = 0; init(); initCounters(); initClip(); });
})();
